import * as api from "../api/summaryApi";
import store from "../store/store";
import type { SummaryType } from "../types/statsType";
export default class SummaryLogic {
  /**
   * updates summary stats
   */
  static updateSummary(summary?: SummaryType) {
    // If no summary object is passed, fetch summary from api
    if (summary) {
      store.dispatch.betSlipListModel.setCurrentBetsCount(summary["openBets"]);
      store.dispatch.bookmarkListModel.setBookmarksTotal(summary.bookmarks);
      store.dispatch.favouritesListModel.setCurrentFavouritesCount(
        summary.favourites
      );
      store.dispatch.positionMatrixListModel.setPositionMatrixListTotal(
        summary["openPositions"]
      );
    } else {
      api.fetchSummary().then(resp => {
        const accountStats = resp.accountStats;
        store.dispatch.betSlipListModel.setCurrentBetsCount(
          accountStats["openBets"]
        );
        store.dispatch.bookmarkListModel.setBookmarksTotal(
          accountStats.bookmarks
        );
        store.dispatch.favouritesListModel.setCurrentFavouritesCount(
          accountStats.favourites
        );
        store.dispatch.positionMatrixListModel.setPositionMatrixListTotal(
          accountStats["openPositions"]
        );
      });
    }
  }
}
